var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrowUpRight = function SvgArrowUpRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 22h18V7",
    stroke: "#2B2634",
    fill: "transparent",
    strokeWidth: 2,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 16.5 3 22l5 5.5",
    stroke: "#2B2634",
    strokeWidth: 2,
    strokeLinecap: "square",
    fill: "transparent"
  })));
};
export { SvgArrowUpRight as ReactComponent };
export default __webpack_public_path__ + "c4358ddb1e065e2fc3b040e272b12209.svg";